import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { PageView } from "../components";
export var handlePreviousPage = function handlePreviousPage(selected, setSelected, onPageChange) {
  //if selected page greater than first page we can go to prev page
  if (selected > 0) {
    handlePageSelected(selected, selected - 1, setSelected, onPageChange);
  }
};
export var handleNextPage = function handleNextPage(selected, pageCount, setSelected, onPageChange) {
  //if selected page is lower than last page we can go to next page
  if (selected < pageCount - 1) {
    handlePageSelected(selected, selected + 1, setSelected, onPageChange);
  }
}; // onClick for button navigator that moves 5 pages forward

export var handleNext5page = function handleNext5page(selected, pageCount, setSelected, onPageChange) {
  // if selected + 5 is more than available pages then navigate to last page otherwise navigate to the destination page
  handlePageSelected(selected, selected + 5 > pageCount - 1 ? pageCount - 1 : selected + 5, setSelected, onPageChange);
}; // onClick for button navigator that moves 5 pages back

export var handleLast5page = function handleLast5page(selected, pageCount, setSelected, onPageChange) {
  // if selected - 5 is less than 0 then navigate to 0 otherwise navigate to the destination page
  handlePageSelected(selected, selected - 5 < 0 ? 0 : selected - 5, setSelected, onPageChange);
};
export var handlePageSelected = function handlePageSelected(selected, selectedPage, setSelected, onPageChange) {
  //if we click on selected page ,break this function
  if (selected === selectedPage) return;
  setSelected(selectedPage);
  onPageChange(selectedPage);
};
export var pagination = function pagination(selected, pageCount, onPageChange, setSelected) {
  var items = []; // add first item no matter what

  items.push(0);

  if (pageCount <= 6) {
    for (var i = 0; i < pageCount - 1; i++) {
      if (i !== 0) {
        items.push(i);
      }
    }
  } else if (pageCount === 7 && selected >= 3) {
    for (var _i = 0; _i < pageCount - 1; _i++) {
      if (_i !== 0) {
        items.push(_i);
      }
    }
  } else {
    // show first 5 items but 0th
    if (selected < 4) {
      for (var _i2 = 0; _i2 < 5; _i2++) {
        if (_i2 !== 0) {
          items.push(_i2);
        }
      } // if selected page is 3 we add a move forward button after 5


      if (selected === 2) {
        items.push(-1);
      } // if page 4 is selected then show 6th page too and add a move forward button after it


      if (selected === 3) {
        items.push(5);
        items.push(-1);
      }
    } // if selected page is 5th or more we follow the following rules


    if (selected >= 4) {
      // if there are 5 more pages left after the selected page
      if (pageCount - selected >= 5) {
        // show a button navigator for last 5 pages
        items.push(-2);
        items.push(selected - 2);
        items.push(selected - 1);

        if (selected !== pageCount - 1) {
          items.push(selected);
        }
      } // if there are less than 5 pages left after the selected page show rest


      if (pageCount - selected < 5) {
        //if selected is page 7 then show 5 and 6 too
        if (selected === pageCount - 1 - 3) {
          items.push(-2);
          items.push(pageCount - 4 - 2);
          items.push(pageCount - 4 - 1);
        } // for after page 7 show from 6


        if (selected > pageCount - 1 - 3) {
          items.push(-2);
          items.push(pageCount - 4 - 1);
        }

        for (var _i3 = 3; _i3 > 0; _i3--) {
          items.push(pageCount - 1 - _i3);
        }
      } else {
        // show 2 more pages after selected page
        items.push(selected + 1);
        items.push(selected + 2); // show a button navigator for next 5 pages

        items.push(-1);
      }
    } // if selected page first or second page show button to move 5 pages forward before last page


    if (selected === 0 || selected === 1) {
      items.push(-1);
    }
  } // add last item but if pageCount is 1 dont add because its already added above


  if (pageCount !== 1) {
    items.push(pageCount - 1);
  } //for every item in array ,we return pageView component that return page elements


  return items.map(function (index) {
    return /*#__PURE__*/_jsx(PageView, {
      selected: selected,
      pageCount: pageCount,
      index: index,
      setSelected: setSelected,
      onPageChange: onPageChange
    }, index);
  });
};
export var googlePagination = function googlePagination(selected, pageCount, onPageChange, setSelected) {
  var items = [];

  if (selected > 3) {
    items.push(selected - 3);
    items.push(selected - 2);
    items.push(selected - 1);
    items.push(selected);

    for (var i = 1; i < 4; i++) {
      if (selected + i < pageCount) {
        items.push(selected + i);
      }
    }
  } else {
    if (pageCount > 7) {
      for (var _i4 = 0; _i4 < 7; _i4++) {
        items.push(_i4);
      }
    } else {
      for (var _i5 = 0; _i5 < pageCount; _i5++) {
        items.push(_i5);
      }
    }
  } //for every item in array ,we return pageView component that return page elements


  return items.map(function (index) {
    return /*#__PURE__*/_jsx(PageView, {
      selected: selected,
      pageCount: pageCount,
      index: index,
      setSelected: setSelected,
      onPageChange: onPageChange
    }, index);
  });
};